export class DropdownOption {
  constructor(public label?: string, public value?: any) {}
}
